export enum MapStyle {
  Default,
  Satellite,
}
